import { render, staticRenderFns } from "./InfoCreateForm.vue?vue&type=template&id=6396e116&"
import script from "./InfoCreateForm.vue?vue&type=script&lang=js&"
export * from "./InfoCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports